import React from 'react'
import {ViewContext} from "../ViewContextProvider";

export const useViewContext = () => React.useContext(ViewContext)